import React, { createContext, useContext, useReducer } from "react";
import { reducer, initialState } from "./reducer";

const AppStateContext = createContext();
AppStateContext.displayName = "AppStateContext";

export const useAppState = () => {
    const data = useContext(AppStateContext);
    if (!data) throw new Error(`useAppState must be used within an AppStateProvider.`);
    return data;
};

export const AppStateProvider = ({ ...props }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return <AppStateContext.Provider value={[state, dispatch]} {...props} />;
    
};
